import { isNil, size } from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import Flx from "../../../components/layout/Flx";
import ToggleNavigation from "../../../components/navigation/ToggleNavigation";
import { useLoanPipelineScreenHook } from "../useLoanPipelineScreenHook";
import { LOAN_PIPELINE_FILTER_LABEL_ALL } from "../../../constants/loanPipeline/LOAN_PIPELINE_FILTER_LABEL_ALL";

const LoanPipelineSelector = ({ loans, onChange, value }) => {
  const loanPipelineFull = useSelector((state) => state.loanPipeline);
  const loanPipeline = loans || loanPipelineFull;
  const { loanPipelineList } = useLoanPipelineScreenHook();

  const pipelineTabs = useMemo(() => {
    if (isNil(loanPipeline)) {
      return loanPipelineList;
    }
    const getLabel = (pipelineTab) => {
      let count = 0;
      if (pipelineTab === LOAN_PIPELINE_FILTER_LABEL_ALL) {
        count = size(loanPipeline);
      } else {
        count = size(
          loanPipeline?.filter((loan) => loan?.pipeline === pipelineTab)
        );
      }
      return `${pipelineTab} (${count})`;
    };
    return loanPipelineList?.map((pipelineTab) => ({
      label: getLabel(pipelineTab),
      value: pipelineTab,
    }));
  }, [loanPipeline, loanPipelineList]);

  return (
    <ToggleNavigation
      className="pipeline-selector"
      tabs={pipelineTabs}
      value={value}
      onChange={onChange}
    />
  );
};

export default LoanPipelineSelector;
